export default __webpack_public_path__ + "static/media/marker-blue-red-orange.982d8fda.png";